import { useContext } from 'react';
import { TenantSetupContext, TenantSetupContextInterface } from './TenantSetupContext';

export const useTenantSetupContext = (): TenantSetupContextInterface => {
  const context = useContext(TenantSetupContext);
  if (!context) {
    throw new Error('useTenantSetupContext must be used within a TenantSetupProvider');
  }
  return context;
};
